export default `float de(vec3 p){
    float smallRadius = 1.; 
    float largeRadius = 2.; 

    return length(vec2(length(p.xz) - largeRadius, p.y)) - smallRadius;
  }

Alternate method using circular line SDF - subtract minor radius from result

  float de(vec3 p){
    float r = 1.; 
    float l = length(p.xz) - r;

    return length(vec2(p.y, l));
  }`